import { Box } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useInfiniteHits } from 'react-instantsearch';

import { VehicleExtended } from '@/types/details-car/details-car.types';

import { CarTile } from '../../_components/car-tile/car-tile';
import SearchResultsPlaceholder from '../../_components/search/search-results/search-results-loading';
import { getVehicles } from '../actions';

import styles from './UsedCarInfiniteHits.module.scss';

export function UsedCarInfiniteHits() {
  const { items, isLastPage, showMore } = useInfiniteHits();
  const sentinelRef = useRef(null);

  const [vehicles, setVehicles] = useState<VehicleExtended[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const ids = items.map((item) => {
      return item.id;
    });

    if (ids.length > 0) {
      getVehicles(ids).then((vehicles) => {
        /*
         * filter vehicles if null
         * due to out sync of algolia and directus some vehicles returns as null
         * */
        const filteredVehicles = vehicles.filter((vehicle) => !!vehicle);

        setVehicles(filteredVehicles);
        setLoading(false);
      });
    } else {
      setLoading(false);
      setVehicles([]);
    }
  }, [items]);

  useEffect(() => {
    if (sentinelRef.current !== null) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isLastPage) {
            showMore();
          }
        });
      });

      observer.observe(sentinelRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }, [isLastPage, showMore]);

  if (!items.length) return null;

  return (
    <Box
      position="absolute"
      top="10"
      height="800"
      overflowY="scroll"
      background="white"
      width="full"
      className={styles.infiniteHits}
    >
      {loading ? <SearchResultsPlaceholder /> : null}
      {vehicles.map((vehicle) => (
        <CarTile key={vehicle.id} details={vehicle} />
      ))}
      <div ref={sentinelRef} aria-hidden="true" />
    </Box>
  );
}
